import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id CC3BEE2C-0FEA-46D2-BC53-F7D248AAF47C
 * name reply
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/reply.svg
 * tags
 * - Arrow 
 */
export const ReplyIcon = createSvgIcon(<><path d="M10,9V5L3,12L10,19V14.9C15,14.9 18.5,16.5 21,20C20,15 17,10 10,9Z" /></>, 'ReplyIcon');
export default ReplyIcon